import React, { useState, useRef } from 'react';
import { forgetPassword } from '../../actions/authActions';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';

const ForgetPassword = (props) => {
  const navigate = useNavigate();

  let initialState = { email: '' };
  const [state, setState] = useState(initialState);
  const [disable, setDisable] = useState(true);

  const emailRef = useRef(null);

  const handleChange = (e) => {
    initialState[e.target.id] = e.target.value;
    setState(initialState);
    setDisable(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.forgetPassword({ email: state.email });
    emailRef.current.reset();

    setTimeout(() => {
      navigate('/connexion');
    }, 8000);
  };

  return (
    <Container className='connexion wrapper mt-5'>
      <XyzTransition appear xyz='fade flip-down stagger delay-4 duration-15'>
        <legend>
          <h3 className='d-flex justify-content-center'>
            Mot de passe oublié ?
            </h3>
        </legend>
      </XyzTransition>
      <XyzTransition
        appear
        xyz='fade small out-down delay-2 duration-10 appear-stagger ease-out-back'
      >
        <Form ref={emailRef} autoComplete='off' onSubmit={handleSubmit}>
          <Form.Group controlId='email'>
            <Form.Label>Email:</Form.Label>
            <div className='input-group mb-3'>
              <Form.Control
                type='email'
                required
                onChange={handleChange}
                autoComplete='off'
                className='form-control'
              />
            </div>
            <Button
              type='submit'
              variant='primary'
              className='submit mt-1'
              disabled={disable}
            >
              Récupérer
              </Button>
          </Form.Group>
          <p className='d-flex justify-content-end mt-2'>
            <Link to='/connexion' className='log-out'>
              Déjà inscrit ? Connectez-vous
              </Link>
          </p>
        </Form>
      </XyzTransition>
    </Container>
  );
};

const mapStateToProps = (state) => {
  const uid = state.firebase.auth.uid;
  return {
    uid: uid
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    forgetPassword: (creds) => dispatch(forgetPassword(creds))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);
